<template>
  <section class="section">
    <div class="container">
      <b-field label="Username">
        <b-input v-model="user.username" @keyup.enter.native="login"></b-input>
      </b-field>
      <b-field label="Password">
        <b-input type="password" v-model="user.password" @keyup.enter.native="login"></b-input>
      </b-field>
      <button class="button is-primary" @click="login">Login</button>
    </div>
  </section>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'login',
  data() {
    return {
      user: {
        email: '',
        username: '',
        password: '',
      },
      lang: 'it',
    }
  },
  async created() {
    if (this.$route.query.username && this.$route.query.pwd) {
      this.user.username = this.$route.query.username
      this.user.password = this.$route.query.pwd
      await this.login()
    }
  },
  methods: {
    async login() {
      const usersDoc = await this.$db
        .collection('users')
        .where('username', '==', this.user.username)
        .get()
      usersDoc.forEach(doc => {
        this.user.email = doc.data().email
        this.lang = doc.data().language
      })
      try {
        await firebase.auth().signInWithEmailAndPassword(this.user.email, this.user.password)
        this.$store.dispatch('selectLanguage', this.lang)
        this.$i18n.locale = this.lang
        this.$router.push('/')
      } catch (error) {
        alert(`Non autorizzato ${error.message}`)
      }
    },
  },
}
</script>
